import {
  CheckmarkCircleOutlineIc,
  ChevronUpIc,
  ChevronDownIc,
} from '@dsch/dd-icons';
import { useState } from 'react';
import styled from 'styled-components';

import { Link } from '../../../../components/Toolkit/Button/Link';
import { KeyInfoList } from '../../../../components/Toolkit/KeyInfoList/KeyInfoList';
import { InfoTitle } from '../../../../components/Toolkit/InfoTitle/InfoTitle';

import { Panel } from '../../../../components/HubPages/components/Panel';

const Content = styled.div<{ showVehicleDetails: boolean }>`
  display: ${({ showVehicleDetails }) =>
    showVehicleDetails ? 'block' : 'flex'};
  margin-bottom: ${({ theme, showVehicleDetails }) =>
    showVehicleDetails ? theme.spacing.M16 : '0'};
`;

const DisplayTextLink = styled(Link)<{ showVehicleDetails: boolean }>`
  margin-left: ${({ theme, showVehicleDetails }) =>
    showVehicleDetails ? '0' : theme.spacing.M32};
`;

const SCheckmarkCircleOutlineIc = styled(CheckmarkCircleOutlineIc)`
  color: ${({ theme }) => theme.colors.GREEN};
  align-self: flex-end;
  margin-bottom: ${({ theme }) => theme.spacing.S4};
  margin-right: ${({ theme }) => theme.spacing.M16};
`;

const SInfoTitle = styled(InfoTitle)`
  margin-bottom: 0;
`;

const ShowMoreShowLessText = styled.span`
  margin-right: ${({ theme }) => theme.spacing.S4};
`;

export interface IKeyInfoShowMore {
  infoList: any;
  keyInfoTitle: string;
  keyInfoListItems: string[];
}
function KeyInfoShowMore({
  infoList,
  keyInfoTitle,
  keyInfoListItems,
}: IKeyInfoShowMore) {
  const [showVehicleDetails, setShowVehicleDetails] = useState<boolean>(false);

  return (
    <Panel>
      <Content showVehicleDetails={showVehicleDetails}>
        {showVehicleDetails ? (
          <KeyInfoList infoList={infoList} keyDark={true} />
        ) : (
          <>
            <SCheckmarkCircleOutlineIc width={16} height={16} />

            <SInfoTitle
              title={keyInfoTitle}
              listItems={keyInfoListItems}
              className="common-margin-bottom"
              variant="DEFAULT"
              dataTestId="greenlight-registration-lookup"
            />
          </>
        )}
      </Content>
      <DisplayTextLink
        ofType="SECONDARY"
        onClick={() => setShowVehicleDetails(!showVehicleDetails)}
        showVehicleDetails={showVehicleDetails}
        underline
      >
        <ShowMoreShowLessText>
          {showVehicleDetails ? 'Show Less' : 'Show More'}
        </ShowMoreShowLessText>
        {showVehicleDetails ? (
          <ChevronUpIc width={16} height={16} />
        ) : (
          <ChevronDownIc width={16} height={16} />
        )}
      </DisplayTextLink>
    </Panel>
  );
}

export { KeyInfoShowMore };
